import { ResourceStore } from "@bryntum/schedulerpro";
import { SwivuSortedGroupersMixin } from "./mixins/SwivuSortedGroupersMixin";
import { PlanTaskModel } from "../models/Task";
import { SwivuStoreArchiveMixin } from "./mixins/SwivuStoreArchiveMixin";

export class SwivuPlanResourceStore extends SwivuSortedGroupersMixin(SwivuStoreArchiveMixin(ResourceStore)) {
  static get $name() {
    return "SwivuPlanResourceStore";
  }

  static get configurable() {
    return {
      modelClass: PlanTaskModel
    };
  }
}
